import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import * as colunasGridOrcamentoActions from 'app/redux/colunasGridOrcamentoSlice';
import { IColuna } from "app/types/IColuna";
import globalMU from "globalMU";
import pMemoize from 'p-memoize';

// Cache em memória para resultados
// 472226 - const colunasCache = new Map<string, IColuna[]>();

// Padrões reutilizáveis
const COLUNA_ESTOQUE_REGEX = /F[0-9]{2}/;
const COLUNAS_PADRAO = {
    Acoes: { Nome: "Acoes", Codigo: 0, Permitido: true, Selecionada: true },
    Referencia: { Nome: "Referencia", Codigo: 0, Permitido: true, Selecionada: true },
    Codigo: { Nome: "Codigo", Codigo: 0, Permitido: true, Selecionada: true }
} as Record<string, IColuna>;

export type ObterColunasGridItensInput = {
    fazerCache?: boolean;
    usarCacheSePossivel?: boolean;
    valorParametro_CHAVE_MOVIMENTACAO_ORCAMENTO?: "R" | "C" | "" | null | undefined;
};

export const obterColunasGridItens = pMemoize(async ({
    fazerCache = true,
    usarCacheSePossivel = true,
    valorParametro_CHAVE_MOVIMENTACAO_ORCAMENTO = ""
}: ObterColunasGridItensInput = {}): Promise<IColuna[]> => {
    
    // 1. Gerar chave única para cache
    const cacheKey = JSON.stringify({
        chaveMov: valorParametro_CHAVE_MOVIMENTACAO_ORCAMENTO,
        usarCache: usarCacheSePossivel
    });
    
    // 2. Verificar cache em memória
    // 472226 - if (colunasCache.has(cacheKey)) {
    //     return colunasCache.get(cacheKey)!;
    // }

    const colunasRedux = store.getState().colunasGridOrcamento;
    const valorChaveMov = globalMU.isNullOrEmpty(valorParametro_CHAVE_MOVIMENTACAO_ORCAMENTO) 
        ? "C" 
        : valorParametro_CHAVE_MOVIMENTACAO_ORCAMENTO;

    // 3. Usar cache do Redux se disponível e solicitado
    if (usarCacheSePossivel && colunasRedux.length > 0) {
        //472226 -  colunasCache.set(cacheKey, colunasRedux);
        return colunasRedux;
    }

    // 4. Obter dados em paralelo
    const [colunasGerais, colunasEstoque] = await Promise.all([
        // Colunas principais
        usarCacheSePossivel && colunasRedux.length > 0 
            ? colunasRedux 
            : microuniversoApi.Seguranca.obterDadosGridOrcamento()
                .then(res => res?.Colunas || []),
        
        // Colunas de estoque
        microuniversoApi.Seguranca.obterDadosGridOrcamentoEstoque()
            .then(res => res || [])
    ]);

    // 5. Processamento otimizado
    const colunas = [
        ...colunasGerais
            .filter(c => c.Nome !== "InputFilial" && !COLUNA_ESTOQUE_REGEX.test(c.Nome)),
        ...colunasEstoque
    ];

    // 6. Adicionar colunas padrão se necessário
    if (!colunas.some(c => c.Nome === "Acoes")) {
        colunas.push(COLUNAS_PADRAO.Acoes);
    }

    if (valorChaveMov === "R" && !colunas.some(c => c.Nome === "Referencia")) {
        colunas.push(COLUNAS_PADRAO.Referencia);
    } else if (valorChaveMov === "C" && !colunas.some(c => c.Nome === "Codigo")) {
        colunas.push(COLUNAS_PADRAO.Codigo);
    }

    // 7. Atualizar caches
    if (fazerCache && colunasRedux.length === 0) {
        store.dispatch(colunasGridOrcamentoActions.atualizar(colunas));
    }
    
    //472226 - colunasCache.set(cacheKey, colunas);
    return colunas;
});